import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import InputField from './InputField'

const DialogCambioPassword = ({ open, handleClose, triggerFunction }) => {
  const [oldPassword, setOldPassword] = useState('')
  const [newPassword, setNewPassword] = useState('')

  useEffect(() => {
    setOldPassword('')
    setNewPassword('')
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(oldPassword, newPassword)}
      title='Cambio password'
      textConfirm='Conferma'
    >
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid size={12}>
          <InputField
            id='old-password'
            value={oldPassword}
            onChange={setOldPassword}
            errorFunc={() => !oldPassword}
            autoFocus
            label='Vecchia password'
            type='password'
          />
        </Grid>
        <Grid size={12}>
          <InputField
            id='new-password'
            value={newPassword}
            onChange={setNewPassword}
            errorFunc={() => !newPassword}
            label='Nuova password'
            type='password'
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogCambioPassword
